import _ from 'lodash';
import {FETCH_FULL_PRODUCTS, CLEAN_FULL_PRODUCTS, DELETE_FULL_PRODUCT, DELETE_FULL_PRODUCTS} from './types';
import { request, __ } from '../functions';

export const fetchFullProducts = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/products-full', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_FULL_PRODUCTS, payload: data });
    });
};

export const deleteFullProduct = (screen, id) => {
    return dispatch => request(`/products-full/delete/${encodeURIComponent(id)}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Produkt sa nepodarilo zmazat
            screen.showSnackbar('error', __('Nepodarilo sa zmazať produkt'));
            return;
        }

        screen.showSnackbar('success', __('Produkt bol zmazaný'));

        dispatch({ type: DELETE_FULL_PRODUCT });
    });
};

export const deleteFullProducts = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/products-full/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Produkty sa nepodarilo zmazat
            screen.showSnackbar('error', __('Nepodarilo sa zmazať produkty'));
            return;
        }

        screen.showSnackbar('success', __('Produkty boli zmazané'));

        dispatch({ type: DELETE_FULL_PRODUCTS });
    });
};

export const cleanFullProducts = () => ({ type: CLEAN_FULL_PRODUCTS });
